import { json, max, scaleSqrt } from "d3";
import { useState, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  LayerGroup,
  GeoJSON,
} from "react-leaflet";
import useData from "../../Data/UseData";
import Legend from "./Legend";
import MapMarks from "./MapMarks";
import countries from "./world.json";

const MapSection = (props) => {
  const vacData = useData("Violence against civilians");
  const riotData = useData("Riots");
  const ervData = useData("Explosions/Remote violence");
  const battleData = useData("Battles");

  const vacPoints = useRef();
  const riotPoints = useRef();
  const ervPoints = useRef();
  const battlePoints = useRef();

  const [map, setMap] = useState();

  const centers = {
    colombia: { center: [3.7, -72.2], zoom: 5.4 },
    caucasus: { center: [45.3325, 65.6774], zoom: 4 },
    drc: { center: [-4.0875, 22.4374], zoom: 5.4 },
    haiti: { center: [18.9899, -73.295], zoom: 7.5 },
    kurdistan: { center: [33.3185, 42.461], zoom: 5.4 },
    myanmar: { center: [19.5274, 95.9058], zoom: 5.3 },
    nigeria: { center: [9.1135, 7.9957], zoom: 5.8 },
    sahel: { center: [14.4996, -0.725], zoom: 5.2 },
    ukraine: { center: [48.5409, 31.0081], zoom: 5.2 },
    yemen: { center: [15.822, 47.4901], zoom: 6 },
  };

  if (!vacData || !riotData || !ervData || !battleData) return "loading";

  const focusCountries = ["Myanmar"]
  // ["Armenia", "Azerbaijan", "Kazakhstan", "Tajikistan", "Kyrgyzstan", "Georgia", "Uzbekistan"];
  const overlayCountries = countries.features.filter(
    (d) => !focusCountries.includes(d.properties.NAME)
  );
  console.log(props.vacData)

  const sizeValue = (d) => d.eventCount;

  map &&
    map.on("zoomend moveend",  () => {
      if (map.getZoom() !== centers[props.focusCountry].zoom) {
        document.querySelector("#reset-zoom-button").style.display = "flex";
      } else if (map.getZoom() === centers[props.focusCountry].zoom) {
        if (map.getCenter() !== centers[props.focusCountry].center) {
          document.querySelector("#reset-zoom-button").style.display = "flex";
        } else {
          document.querySelector("#reset-zoom-button").style.display = "none";
        }
      }
    });

  const centerMapHandler = () => {
    map.flyTo(
      centers[props.focusCountry].center,
      centers[props.focusCountry].zoom,
      {
        animate: true,
        duration: 0.4
      }
    );
  };

  const maxValue = max([
    max(vacData, sizeValue),
    max(riotData, sizeValue),
    max(ervData, sizeValue),
    max(battleData, sizeValue),
  ]);

  const sizeScale = scaleSqrt().domain([1, maxValue]).range([3, 18]);

  const tilesetKey = "clbnwkepa000014p3wcbx00qu";
  return (
    <div
      id="map"
      style={{
        height: "100%",
        width: props.width,
        background: "#a1c7e9",
        position: "relative",
      }}
    >
      <MapContainer
        center={centers[props.focusCountry].center}
        zoom={centers[props.focusCountry].zoom}
        zoomSnap={0.2}
        zoomDelta={0.5}
        //scrollWheelZoom={false}
        //zoomControl={false}
        doubleClickZoom={false}
        //dragging={true}
        whenReady={(thisMap) => setMap(thisMap.target)}
        style={{ height: props.height, width: props.width }}
      >
        <TileLayer
          url={`https://api.mapbox.com/styles/v1/acled/${tilesetKey}/tiles/512/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYWNsZWQiLCJhIjoiY2w5d29wMXA4MDM3NzN4bm9qMHZpaXB1NSJ9.OA8wiwj1HPnRPcaz-JLfRA`}
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
        />
        <GeoJSON data={overlayCountries} className="overlay" />
        <LayerGroup ref={vacPoints}>
          <MapMarks
            data={vacData}
            sizeScale={sizeScale}
            fillColor={props.colourScale("Violence against civilians")}
          />
        </LayerGroup>
        <LayerGroup ref={riotPoints}>
          <MapMarks
            data={riotData}
            sizeScale={sizeScale}
            fillColor={props.colourScale("Riots")}
          />
        </LayerGroup>
        <LayerGroup ref={ervPoints}>
          <MapMarks
            data={ervData}
            sizeScale={sizeScale}
            fillColor={props.colourScale("Explosions/Remote violence")}
          />
        </LayerGroup>
        <LayerGroup ref={battlePoints}>
          <MapMarks
            data={battleData}
            sizeScale={sizeScale}
            fillColor={props.colourScale("Battles")}
          />
        </LayerGroup>
      </MapContainer>

      <Legend
        vacPoints={vacPoints}
        riotPoints={riotPoints}
        ervPoints={ervPoints}
        battlePoints={battleData}
        map={map}
        width={props.width}
        height={props.height}
        colours={props.colours}
        eventTypes={props.eventTypes}
        colourScale={props.colourScale}
        sizeScale={sizeScale}
      />
      <div
        id="reset-zoom-button"
        className="f-small flex-center"
        style={{
          position: "absolute",
          cursor:"pointer",
          top: -2,
          left: props.width,
          transform: "translate(-100%,0)",
          width: 90,
          height: 30,
          background: "#12425e",
          color: "white",
          display: "none",
        }}
        onClick={centerMapHandler}
      >
        <p>
          <strong>Reset Zoom</strong>
        </p>
      </div>
    </div>
  );
};

export default MapSection;
